import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import tagsView from './modules/tagsView'
import dict from './modules/dict'
import permission from './modules/async-router'
import getters from './getters'
import menu from './modules/menu'
import multiTab from './modules/multiTab'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		app,
		user,
		tagsView,
		dict,
		permission,
		menu,
		multiTab
	},
	state: {
		customerList: [],
		newIndex: 0,
		newPage: 1,
		// 【关键】从本地缓存读取，没有就用默认 true（打开状态）
		showHelpIcon: localStorage.getItem('showHelpIcon') === 'true'
	},
	mutations: {
		SET_CUSTMOER_LIST: (state, arr) => {
			state.customerList = arr;
		},
		SET_NEWINDEX: (state, index) => {
			state.newIndex = index;
		},
		SET_NEWPAGE: (state, index) => {
			state.newPage = index;
		},
		// 【修改】改状态同时存入 localStorage
		SET_SHOW_HELP_ICON: (state, val) => {
			state.showHelpIcon = val;
			localStorage.setItem('showHelpIcon', val); // 持久化到本地
		}
	},
	actions: {
		setList({ commit }, arr) {
			commit('SET_CUSTMOER_LIST', arr)
		},
		setIndex({ commit }, index) {
			commit('SET_NEWINDEX', index)
		},
		setPage({ commit }, index) {
			commit('SET_NEWPAGE', index)
		},
	},
	getters
})